module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/alpine-9d873f0c21a02a924d8534a918da1b01.png";